<mat-card-title *ngIf="statusPageParams && statusPageParams.statusTitle">{{ statusPageParams.statusTitle | translate }}</mat-card-title>

<div class="container" fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="0.5%" fxLayoutAlign="center">
    <div fxFlex="20%">
        <img mat-card-image [src]=statusPageParams.logoUri alt="Image of a sad face">
    </div>
</div>

<mat-card-content *ngIf="statusPageParams && statusPageParams.statusContent">
    <p>
        {{statusPageParams.statusContent| translate}}
    </p>
</mat-card-content>

<!-- <ng-container>
    <mat-card-actions>
        <app-button (clickEvent)="commonFunc.getRedirectedByRequestId()" [btnOption]="buttonOptions.backToLogin">
        </app-button>
    </mat-card-actions>
</ng-container>-->